export default __webpack_public_path__ + "static/media/ShrinkFittingImg.141e3146.jpg";